const modalTable = () => {
    const table = document.querySelector('.archive-venue-filter__modal table');
    if (table) {
        const caption = table.querySelector('caption');
        const wrapper = document.querySelector('.archive-venue-filter__modal-content-wrapper');
        const thead = table.querySelector('thead');
        const thWidth = table.querySelectorAll('th:first-child, th:nth-child(2)');
        let elementsWidth = 0;

        [...thWidth].forEach(element => {
            elementsWidth += element.clientWidth;
        });

        if (window.matchMedia('screen and (min-width: 992px)').matches) {
            caption.style.right=`${wrapper.clientWidth - wrapper.scrollWidth}px`;
            caption.style.width=`${thead.clientWidth - elementsWidth}px`;
        } else {
            caption.removeAttribute('style');
        }
    }
}

export default modalTable;